import React from 'react';

import axios from "axios";
import config from "./config";
import {removeSlash} from './api';


class CoreData {
    static url = "/patients/";

    constructor(props) {
    }

    static handleDataChange(patient, path, data, instanceId, signal) {
        return new Promise(async function (resolve, reject) {
            let postData = {set: {}};
            postData.set[path] = data.data.value;
            axios.post(config.coredsUrl + CoreData.url + removeSlash(patient) + `?noResp=True${instanceId ? "&instance_id=" + instanceId : ""}`,
                postData, {signal})
                .then(response => {
                    resolve(data);
                }).catch(error => {
                if (error?.message !== "canceled") {
                    console.error("CoreData handleDataChange error", error);
                    reject(error);
                }
            });
        });
    }

    static async getData(patient, path, signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.coredsUrl + CoreData.url + removeSlash(patient) + "/getval?key=" + path, {signal}).then(response => {
                resolve(response.data ? {data: {value: response.data.val, by: response.data.createdBy, when: response.data.createdDate}} : null);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    console.error("CoreData getData error", error);
                    reject(error);
                }
            });
        });
    }

    static async getHist(patient, path, signal) {
        return new Promise(async function (resolve, reject) {
            axios.get(config.coredsUrl + CoreData.url + removeSlash(patient) + "/gethist?last_cnt=5&key=" + path, {signal}).then(response => {
                resolve(response.data ? response.data : null);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    console.error("CoreData getHist error", error);
                    reject(error);
                }
            });
        });
    }

    static async deleteHist(patient, histId, signal) {
        return new Promise(async function (resolve, reject) {
            axios.delete(config.coredsUrl + CoreData.url + removeSlash(patient) + "/hist/" + histId, {signal}).then(response => {
                resolve(response.data ? response.data : null);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    console.error("CoreData getHist error", error);
                    reject(error);
                }
            });
        });
    }
}

export default CoreData;
